import React, {Component} from 'react';
import {Panel} from 'react-bootstrap'
import CrudComponent from './../zynappse-crud'
import CardType from '../schema/CardType.json'
import './style.less';

class Profile extends Component {
	render() {
		console.log('cardType',CardType)
		console.log('========================================')
		return (
			<Panel>
				<Panel.Heading style={{
					backgroundColor: '#D1282F',
					color: 'white'
				}}>
					<h4>{CardType.classNameLabel.toUpperCase()}</h4>
				</Panel.Heading>
				<Panel.Body>
					<CrudComponent schema={CardType}/>
				</Panel.Body>
			</Panel>
		);
	}
}

export default Profile;



// WEBPACK FOOTER //
// ./components/profile/index.js